export const isPrefersReducedMotion = () =>
  window.matchMedia('(prefers-reduced-motion: reduce)').matches;
